import React from 'react';
import Summary from "../../common/Summary";

const BeneficiarySummary = () => {
    return (<Summary ownsClaim={false} nextSteps={["If we need any additional information, we'll contact you."]}/>)
};

export default BeneficiarySummary;
